import {TFunction} from 'i18next';
import {Building, Floor, MeetingRoomAmenitiesByBuilding, RoomEquipment} from '@lib/store';
import {
  SECTION_ID_DYNAMIC_ROOM_ACTIVITY_TYPE,
  SECTION_ID_DYNAMIC_ROOM_EQUIPEMENT,
  SECTION_ID_SEATS,
  constructBuildingWithFloorsFilter,
  constructDynamicRoomActivityTypeFilter,
  constructDynamicRoomEquipementFilter,
  constructSeatFilter,
} from '../filterConstructors';

export const constructNewEventAndAdHocRoomFilter = (
  buildings: Building[],
  defaultBuildingId: string,
  floors: Floor[],
  meetingRoomAmenitiesByBuilding: MeetingRoomAmenitiesByBuilding,
  getIconName: (id: RoomEquipment) => string,
  t: TFunction,
) => {
  const seats = constructSeatFilter(t);
  const dynamic = constructBuildingWithFloorsFilter(buildings, defaultBuildingId, floors, t);

  const equipement = constructDynamicRoomEquipementFilter(meetingRoomAmenitiesByBuilding, getIconName, t);
  const activities = constructDynamicRoomActivityTypeFilter(meetingRoomAmenitiesByBuilding, t);

  return {
    [SECTION_ID_SEATS]: seats,
    [SECTION_ID_DYNAMIC_ROOM_ACTIVITY_TYPE]: activities,
    [SECTION_ID_DYNAMIC_ROOM_EQUIPEMENT]: equipement,
    ...dynamic,
  };
};
